// extracted by mini-css-extract-plugin
module.exports = {"body":"r4FvCl3_","header":"eY9eCmCe","container":"CdIuCEMf","menus":"BgcWRK5q","main":"Fx665siu","footer":"n3Wmr4Oe"};